/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*******************************!*\
  !*** ./src/js/tables-page.js ***!
  \*******************************/
// JB: this code is added to the competition logos on the tables page, it toggles between each competition table

var prem = document.querySelector(".tables-prem");
var ecl = document.querySelector(".tables-ecl");
var showPrem = document.querySelector(".show-prem");
var showEcl = document.querySelector(".show-ecl");
showPrem.addEventListener("click", function () {
  showPrem.classList.add('active');
  showEcl.classList.remove('active');
  prem.classList.remove("hidden");
  ecl.classList.add("hidden");
});
showEcl.addEventListener("click", function () {
  showEcl.classList.add('active');
  showPrem.classList.remove('active');
  prem.classList.add("hidden");
  ecl.classList.remove("hidden");
});
/******/ })()
;